/* Wild Flame Konfigurator (Claude, 2026-10-01)
   1. Akkordeon: immer nur eine Ebene offen (details[name], Fallback fuer aeltere Browser).
   2. Nach einem Familienwechsel (Seitenwechsel) bleibt die benutzte Ebene offen, an derselben Stelle.
   3. Varianten-Ebenen: Kopfzeile (Wert + Icon) und Aufpreise folgen der Auswahl.
   4. Sondermass-Panel in die Abmessungs-Ebene, Zusammenfassung ans Ende der Auswahl. */
(function () {
  'use strict';
  var NAV_KEY = 'wfk-nav';

  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function groupLevels(grp) { return qa(document, 'details.wfk-lv[data-wfk-group="' + grp + '"]'); }

  /* 1. Exklusives Akkordeon */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.wfk-lv') || !d.open) return;
    groupLevels(d.getAttribute('data-wfk-group')).forEach(function (o) { if (o !== d && o.open) o.open = false; });
  }, true);

  /* 2. Zustand vor Seitenwechsel merken */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-wfk-nav]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var lv = a.closest('details.wfk-lv');
    if (!lv) return;
    a.classList.add('is-going');
    try {
      sessionStorage.setItem(NAV_KEY, JSON.stringify({
        lv: lv.getAttribute('data-wfk-lv'),
        y: Math.round(lv.getBoundingClientRect().top),
        t: Date.now()
      }));
    } catch (err) {}
  });

  function restore() {
    var st = null;
    try { st = JSON.parse(sessionStorage.getItem(NAV_KEY) || 'null'); sessionStorage.removeItem(NAV_KEY); } catch (err) {}
    if (!st || !st.lv || Date.now() - st.t > 60000) return;
    var lv = document.querySelector('details.wfk-lv[data-wfk-lv="' + st.lv + '"]');
    if (!lv) return;
    lv.open = true;
    var moved = false;
    function place() {
      if (moved) return;
      var top = lv.getBoundingClientRect().top;
      window.scrollTo(0, Math.max(0, window.pageYOffset + top - st.y));
    }
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (err) {}
    place();
    requestAnimationFrame(place);
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { moved = true; }, { once: true, passive: true });
    });
    window.addEventListener('load', function () { setTimeout(place, 60); }, { once: true });
  }

  /* 3. Varianten-Ebenen */
  function money(cents, cur) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur || 'EUR', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (err) { return (cents / 100).toFixed(0) + ' €'; }
  }

  function initVariants(box) {
    var data = null;
    try { data = JSON.parse(box.querySelector('script[data-wfk-variants]').textContent); } catch (err) {}
    var levels = qa(box, 'details.wfk-lv[data-wfk-opt]');
    function current() {
      return levels.map(function (lv) {
        var c = lv.querySelector('input[data-variant-input]:checked');
        return c ? c.value : null;
      });
    }
    function find(opts) {
      if (!data) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.o[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var cur = current();
      var curV = find(cur);
      levels.forEach(function (lv, i) {
        var c = lv.querySelector('input[data-variant-input]:checked');
        if (c) {
          var lab = lv.querySelector('label[for="' + c.id + '"]');
          var hv = lv.querySelector('[data-wfk-hval]');
          var hi = lv.querySelector('[data-wfk-hico]');
          if (lab && hv) hv.textContent = lab.getAttribute('data-wfk-val') || c.value;
          var ico = lab && lab.querySelector('.wfk-t__ico');
          if (ico && hi) hi.innerHTML = ico.innerHTML;
        }
        qa(lv, 'input[data-variant-input]').forEach(function (inp) {
          var lab = lv.querySelector('label[for="' + inp.id + '"]');
          var px = lab && lab.querySelector('[data-wfk-delta]');
          if (!px) return;
          var opts = cur.slice(); opts[i] = inp.value;
          var v = find(opts);
          var d = (v && curV) ? v.p - curV.p : 0;
          px.textContent = d > 0 ? '+ ' + money(d, data && data.currency) : (d < 0 ? '– ' + money(-d, data && data.currency) : '');
        });
      });
    }
    box.addEventListener('change', function (e) { if (e.target.matches('input[data-variant-input]')) setTimeout(update, 0); });
    document.addEventListener('variant:change', function () { setTimeout(update, 0); });
    update();
  }

  /* 4. Sondermass-Panel und Zusammenfassung umhaengen */
  function placeSondermass(root) {
    var slot = root.querySelector('[data-wfk-sm-slot]');
    var sm = root.querySelector('bek-sondermass');
    if (!sm) return;
    /* 2026-10-03 (Claude): bek-sondermass.js wird erst nach dem Laden der Sondermass-Daten gestartet
       (siehe bek-sondermass.liquid). Panel und Zusammenfassung erst umhaengen, wenn das Element bereit ist,
       weil es sie beim Start in sich selbst sucht. */
    function move() {
      var panel = sm.querySelector('[data-bek-sm-panel]');
      if (slot && panel) slot.appendChild(panel);
      var section = root.closest('.product-section') || document;
      var end = section.querySelector('[data-wfk-end]');
      var summary = sm.querySelector('[data-bek-sm-summary]');
      if (end && summary) end.appendChild(summary);
    }
    if (window.customElements && !window.customElements.get('bek-sondermass')) {
      window.customElements.whenDefined('bek-sondermass').then(function () { setTimeout(move, 0); });
    } else {
      move();
    }
    /* Sondermass-Kachel oeffnet die Abmessungs-Ebene mit */
    var toggle = root.querySelector('[data-bek-sm-toggle]');
    if (toggle) toggle.addEventListener('click', function () {
      var lv = toggle.closest('details.wfk-lv');
      if (lv && !lv.open) lv.open = true;
    });
  }

  function init() {
    qa(document, '[data-wfk]').forEach(function (root) {
      if (root.__wfk) return; root.__wfk = true;
      placeSondermass(root);
    });
    qa(document, '[data-wfk-var]').forEach(function (box) {
      if (box.__wfk) return; box.__wfk = true;
      initVariants(box);
    });
    restore();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
